import React, { useEffect, useState } from "react";
import { Modal, Input, List } from "antd";
import { toast } from "react-toastify";
import apiInstance from "../../../services/apiService";
import ENDPOINTS from "../../../services/endpoint";
import CustomLoader from "../UI/Loader";
import "./CitySelectorModal.scss";

interface City {
  id: string;
  value: string;
  npa: string;
}

interface CitySelectorModalProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (city: City) => void;
  state: string | undefined;
}

const CitySelectorModal: React.FC<CitySelectorModalProps> = ({
  visible,
  onClose,
  onSelect,
  state,
}) => {
  const [search, setSearch] = useState<string>("");
  const [citiesList, setCitiesList] = useState<City[]>([]);
  const [loading, setLoading] = useState(false);

  const filteredCities = citiesList.filter((city) =>
    city.value.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    if (visible && !state) {
      toast.error("Please select a State first");
      return;
    }

    if (!visible || !state) return;

    const url = ENDPOINTS.GET_CITIES + `?state=${state}`;
    setLoading(true);

    const getCitiesBystate = async () => {
      try {
        const response = await apiInstance.get(url);
        const data = response.data.data;
        setCitiesList(data);
      } catch (error) {
        console.error(error);
        toast.error("There was an error fetching cities");
      } finally {
        setLoading(false);
      }
    };

    getCitiesBystate();
  }, [state, visible]);

  return (
    <Modal
      title="Select City"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      className="cities-modal custom-modal"
    >
      <Input
        className="city-search-input"
        placeholder="Search..."
        onChange={(e) => setSearch(e.target.value)}
        allowClear
      />
      <List
        className="custom-list"
        loading={{
          spinning: loading,
          indicator: <CustomLoader />,
        }}
        dataSource={filteredCities}
        renderItem={(city) => (
          <List.Item
            key={city.id}
            onClick={() => onSelect(city)}
            style={{
              cursor: "pointer",
              display: "grid",
              gridTemplateColumns: "repeat(3 ,1fr)",
              alignItems: "center",
            }}
          >
            <span>{city.value}</span>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default CitySelectorModal;
